import { apiService } from './api.service';

export enum SubscriptionStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  CANCELED = 'canceled'
}

interface CreateSubscriptionRequest {
  email: string;
  successUrl: string;
  cancelUrl: string;
}

interface CancelSubscriptionResponse {
  success: boolean;
  status: string;
}

class SubscriptionService {
  async createSubscription(email: string): Promise<{ subscriptionUrl: string; subscriptionId: string }> {
    const baseUrl = window.location.origin;
    const request: CreateSubscriptionRequest = {
      email,
      successUrl: `${baseUrl}/tickets/bulk?payment_success=true`,
      cancelUrl: `${baseUrl}/tickets`
    };

    const response = await apiService.post<{ subscriptionUrl: string; subscriptionId: string }>('/subscription', request);
    return response;
  }

  async getSubscriptionStatus(): Promise<SubscriptionStatus> {
    const response = await apiService.get<string>('/subscription/status');
    if (response === 'active') {
      return SubscriptionStatus.ACTIVE;
    } else if (response === 'canceled') {
      return SubscriptionStatus.CANCELED;
    } else {
      return SubscriptionStatus.INACTIVE;
    }
  }

  async cancelSubscription(): Promise<CancelSubscriptionResponse> {
    return await apiService.post<CancelSubscriptionResponse>('/subscription/cancel', {});
  }
}

export const subscriptionService = new SubscriptionService(); 